<!--
 * @Author: ZS
 * @Date: 2020-06-05 15:30:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-17 15:22:46
 * @Description: file content
-->
<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1220px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  border:1px solid #21A1E7;
  background-color:#f4f4f5;
  color: #21A1E7;
}
.el-pager li.active {
  color: #21A1E7;
  border:1px solid #21A1E7;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/App.vue